export default __webpack_public_path__ + "static/media/AdMonsters_09.d3cbc686.png";